import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import React, {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import ResidenceDetailBasicInfo from "./ResidenceDetailBasicInfo";
import ResidenceDetailManagerInfo from "./ResidenceDetailManagerInfo";
import ResidenceDetailMap from "./ResidenceDetailMap";
import {Helmet} from "react-helmet";

export default function ResidenceDetail() {

    const navigate = useNavigate()
    const {state} = useLocation()
    const [searchParams]= useSearchParams()
    const title= searchParams.get("title")
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : title ? title : RouteHelper.ResidenceDetail.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(tabTypes.detail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[

                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.Residences.name,
                                    RouteHelper.Residences.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""
                                ),
                            ]}/>

                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={tabTypes.detail.title}
                                    value={tabTypes.detail.id}/>

                                <Tab
                                    label={tabTypes.mapInfo.title}
                                    value={tabTypes.mapInfo.id}/>

                                <Tab
                                    label={tabTypes.clerkInfo.title}
                                    value={tabTypes.clerkInfo.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={tabTypes.detail.id}>
                            <ResidenceDetailBasicInfo/>
                        </TabPanel>

                        <TabPanel value={tabTypes.clerkInfo.id}>

                            <ResidenceDetailManagerInfo/>
                        </TabPanel>
                        <TabPanel value={tabTypes.mapInfo.id}>
                            <ResidenceDetailMap/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const tabTypes = {
    detail: {
        id: "detail",
        title: "اطلاعات پایه"
    },
    clerkInfo: {
        id: "clerkInfo",
        title: "خادم"
    },
    mapInfo: {
        id: "mapInfo",
        title: "موقعیت مکانی"
    }
}
